export default __webpack_public_path__ + "static/media/aocaboteatro4.f20aa1ed.png";